<!--
  Container for report components:
    ReportHeader  
    ReportStart
    ReportStartTrace
    ReportSection
    About
    PageFooter
-->
<template >
  <v-container fluid class="pa-0">
    <v-toolbar class="transparent flat dark-blue-background white--text" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items class="dark-blue-background white--text">
        <v-btn flat class to="/">Home</v-btn>
        <v-btn flat class @click="dialogTodo = true">Help</v-btn>
        <v-btn flat class @click="dialogTodo = true">Login</v-btn>
        <!-- <v-btn flat class @click="dialogTodo = true">{{ $vuetify.breakpoint.name }}</v-btn> -->
      </v-toolbar-items>
    </v-toolbar>

    <!-- ReportHeader -->
    <v-layout class="dark-blue-background white--text" v-if="this.useTimeLine">
      <v-container class="pa-0">
        <v-timeline dense class="ml-5 mr-5" dark>
          <v-timeline-item
            hide-dot
            fill-dot
            class="white--text pl-3 pt-3"
            color="white"
            icon="expand_more"
            icon-color="#1A2D3C"
            large
          >
            <ReportHeader></ReportHeader>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-layout>
    
    <v-layout v-if="!this.useTimeLine" class="dark-blue-background white--text">
      <v-flex ml-4>
        <ReportHeader></ReportHeader>
      </v-flex>
    </v-layout>
  
    <!-- ReportStart -->
    <v-layout v-if="this.useTimeLine" class="blue-background white--text" id="start">
      <v-container class="pa-0">
        <v-timeline dense class="ml-5 mr-5" dark>
          <v-timeline-item
            fill-dot
            class="white--text pl-3 pt-3"
            color="white"
            icon="view_headline"
            icon-color="#1A2D3C"
            large
          >
            <ReportStart :totalScore="totalScore"></ReportStart>
            <ReportStartTrace
              :htmlGroups="htmlGroups"
              :sections="sections"
              :totalScore="totalScore"
            ></ReportStartTrace>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-layout>
    <v-layout v-if="!this.useTimeLine" class="blue-background white--text" id="start">
      <v-container class="ml-4">
        <ReportStart :totalScore="totalScore"></ReportStart>
        <ReportStartTrace :htmlGroups="htmlGroups" :sections="sections" :totalScore="totalScore"></ReportStartTrace>
      </v-container>
    </v-layout>

    <v-layout v-if="this.useTimeLine" class="white-background blue-text">
      <v-container class="pa-0">
        <v-timeline light dense class="ml-5 mr-5">
          <v-timeline-item
            not-hide-dot
            fill-dot
            class="pl-3 pt-3"
            color="#fce8a4"
            icon="add"
            icon-color="#1A2D3C"
            large
            v-for="section in sections"
            :key="section.groupId"
             @click='gotoTop'
          >
            <!-- A list of sections, driven by the array in data.sections -->
            <ReportSection
              v-bind="htmlGroups.find(g => g.groupId==section.groupId)"
              :image="section.image"
              :hasScore="section.hasScore"
            ></ReportSection>
          </v-timeline-item>
        </v-timeline>
      </v-container>
    </v-layout>
    <v-layout v-if="!this.useTimeLine" class="white-background blue-text mt-0">
      <v-container class="ml-0">
        <!-- A list of sections, driven by the array in data.sections -->
        <ReportSection
          v-for="section in sections"
          :key="section.groupId"
          v-bind="htmlGroups.find(g => g.groupId==section.groupId)"
          :image="section.image"
          :hasScore="section.hasScore"
        ></ReportSection>
      </v-container>
    </v-layout>

    <About></About>
    <PageFooter></PageFooter>
  </v-container>
</template>

<style scoped>
@import "../assets/styles/styles.css";
</style>

<script>
import { overrideQuestionModel } from "../model/override-question-model.js";
import { importedGroupModel } from "../model/imported-group-model.js";
import { SectionAggregator } from "../model/reportBuilder.js";
import ReportHeader from "./ReportHeader.vue";
import ReportStart from "./ReportStart.vue";
import ReportStartTrace from "./ReportStartTrace.vue";
import ReportSection from "./ReportSection.vue";
import About from "./About.vue";
import PageFooter from "./PageFooter.vue";

export default {
  name: "Download",
  components: {
    ReportHeader,
    ReportStart,
    ReportStartTrace,
    ReportSection,
    About,
    PageFooter
  },
  data: () => ({
    questions: overrideQuestionModel.questions,

    // This array controls the order of the groups in the report.
    // The groupId corresponds to the field in imported-group-model.js
    sections: [
      { groupId: "B", hasScore: true },
      { groupId: "C", hasScore: true },
      { groupId: "A", hasScore: true },
      { groupId: "D", hasScore: true },
      { groupId: "E", hasScore: true },
      { groupId: "F", hasScore: false }
    ],
  }),
  computed: {
    answers() { 
      return this.$store.getters.getAnswers(false)
    },
    htmlGroups() {
      const agg = new SectionAggregator();
      return importedGroupModel.groupInfo.map(g => {
        return agg.aggregate(g.groupId, "html", this.questions, this.answers);
      });
    },
    pdfGroups() {
      const agg = new SectionAggregator();
      return importedGroupModel.groupInfo.map(g => {
        return agg.aggregate(g.groupId, "pdf", this.questions, this.answers);
      });
    },
    totalScore() {
      const agg = new SectionAggregator();
      return agg.getTotalScore(this.htmlGroups);
    },
    useTimeLine() {
      return !this.$vuetify.breakpoint.smAndDown;
    }
  },

  created() {
    this.report = Math.max(Math.round(this.totalScore), 1);
  },

  methods: {
    gotoTop: function() {
      this.$vuetify.goTo('#start', {})
    }
  }
};
</script>
